module.exports = __webpack_public_path__ + "static/media/comment-alt-edit.ee82c017.svg";